<template>
  <div
    v-for="discount in store.currentBundlePrice?.Discounts"
    :key="discount.DiscountId"
  >
    <InfoCard
      v-if="discount.Description.length > 0"
      :key="discount.DiscountId"
      :header-class="discount.LabelColor"
      padding-x="px-16 md:px-24"
      padding-y="py-16 md:py-24"
    >
      <template #header>
        <div class="flex gap-16 items-center">
          <nuxt-icon
            name="gift"
            class="text-[3.2rem] mb-0"
            aria-hidden="true"
          />
          <p class="heading-xs text-inherit">
            {{ discount.Name }}
          </p>
        </div>
      </template>
      <MarkupGenerator
        v-if="campaignMarkup(discount.Description) !== null"
        :is-page="false"
        :page-data="campaignMarkup(discount.Description) as any"
      />
    </InfoCard>
  </div>
</template>

<script lang="ts" setup>
import type { MarkupData } from '~/repository/modules/category.module';
const store = useMyProductPageStore();
const campaignMarkup = (discountMarkup: any) => {
  const bodyMarkup = ref<MarkupData | null>(null);
  if (discountMarkup) {
    bodyMarkup.value = {
      PageContent: discountMarkup,
    };
  }
  return bodyMarkup.value;
};
</script>

<style lang="scss" scoped></style>
